import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const STVModal = ({ children, title, show, onClose }) => (
  <Modal show={show} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {children}
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
)

STVModal.defaultProps = {
  onClose: ()=>{},
  show: false,
  title: '',
}

export default STVModal



// WEBPACK FOOTER //
// ./src/components/Modal.js